import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
// import { connect } from 'react-redux';
import CancelableFetchPromise from 'js/CancelablePromise';
import CreateNewWarning from 'components/admin/create-new-warning/CreateNewWarning';
// import AdminHeader from 'components/admin/admin-header/AdminHeader';
import Spinner from 'components/elements/spinner/Spinner';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import ErrorMessage from 'components/elements/error-message/ErrorMessage';
import { trackPageView } from 'js/TrackPage';
import Localization, { setLanguage } from 'languages/screens/admin/AdminLan';

class AdminEditForecast extends Component {
  constructor(props) {
    super(props);

    this.language = setLanguage();

    this.getForecast = this.getForecast.bind(this);
    this.taskGetForecast = null;
    this.getMunicipalityList = this.getMunicipalityList.bind(this);
    this.taskGetMunicipalities = null;
    this.getCountyList = this.getCountyList.bind(this);
    this.taskGetCountyList = null;
    this.sendForm = this.sendForm.bind(this);
    this.taskSendForm = null;
    this.eventHub = props.eventHub;
    this.state = {
      municipalityList: [],
      countyList: [],
      error: false,
      isListLoading: true,
      errorMessage: {
        header: '',
        text: '',
      },
    };
  }

  componentDidMount() {
    this.getForecast();
    this.getMunicipalityList();
    if (this.props.userIsAdmin) {
      this.getCountyList();
    }
    trackPageView('Screen / Admin / Edit Forecast', this.props.location.pathname);
  }

  componentWillUnmount() {
    if (this.taskGetForecast) {
      this.taskGetForecast.cancel();
    }
    if (this.taskGetMunicipalities) {
      this.taskGetMunicipalities.cancel();
    }
  }

  async getForecast() {
    this.taskGetForecast = CancelableFetchPromise(fetch(`${process.env.REACT_APP_API}/api/manualforecast/admin/forecast/${this.props.match.params.id}`,
      {
        headers: {
          Authorization: `Bearer ${this.props.token}`,
          'Accept-Language': this.language,
        },
      }));
    let json = null;
    try {
      json = await this.taskGetForecast.promise;
    } catch (e) {
      this.setState({
        isForecastLoading: false,
        error: true,
        errorMessage: {
          header: Localization.formatString(Localization.errorHeader, json.status),
          text: Localization.errorGetMessage,
        },
      });
      return;
    }

    if (json.status === 401) {
      this.eventHub.emit('logout');
      return;
    }

    if (json.status !== 200) {
      this.setState({
        isForecastLoading: false,
        error: true,
        errorMessage: {
          header: Localization.formatString(Localization.errorHeader, json.status),
          text: Localization.errorGetMessage,
        },
      });
      return;
    }

    json = json.body;

    this.setState({ forecast: json, isForecastLoading: false });
  }

  async getMunicipalityList() {
    this.taskGetForecastList = CancelableFetchPromise(fetch(`${process.env.REACT_APP_API}/api/manualforecast/admin/municipalities`,
      {
        headers: {
          Authorization: `Bearer ${this.props.token}`,
          'Accept-Language': this.language,
        },
      }));
    let json = null;
    try {
      json = await this.taskGetForecastList.promise;
    } catch (e) {
      this.setState({
        isListLoading: false,
        error: true,
        errorMessage: {
          header: Localization.formatString(Localization.errorHeader, json.status),
          text: Localization.errorGetMunicipalitiesMessage,
        },
      });
      return;
    }

    if (json.status === 401) {
      this.props.dispatchLogout();
      return;
    }

    if (json.status !== 200) {
      this.setState({
        isListLoading: false,
        error: true,
        errorMessage: {
          header: Localization.formatString(Localization.errorHeader, json.status),
          text: Localization.errorGetMunicipalitiesMessage,
        },
      });
      return;
    }

    json = json.body;

    const selectDataset = [];

    json.forEach((val) => {
      selectDataset.push({
        value: val.areacode,
        label: `${val.name} - ${val.county}`,
      });
    });

    this.setState({ municipalityList: selectDataset, isListLoading: false });
  }

  async getCountyList() {
    this.taskGetCountyList = CancelableFetchPromise(fetch(`${process.env.REACT_APP_API}/api/manualforecast/admin/counties`, {
      headers: {
        Authorization: `Bearer ${this.props.token}`,
        'Accept-Language': this.language,
      },
    }));
    let json = null;
    try {
      json = await this.taskGetCountyList.promise;
    } catch (e) {
      this.setState({
        error: true,
        isListLoading: false,
        errorMessage: {
          header: Localization.formatString(Localization.errorHeader, json?.status || 'unknown'),
          text: Localization.errorGetCountiesMessage,
        },
      });
      return;
    }

    if (json.status === 401) {
      this.eventHub.emit('logout');
      return;
    }

    if (json.status !== 200) {
      this.setState({
        error: true,
        isListLoading: false,
        errorMessage: {
          header: Localization.formatString(Localization.errorHeader, json.status),
          text: Localization.errorGetCountiesMessage,
        },
      });
      return;
    }

    json = json.body;

    const selectDataset = [];

    json.forEach((val) => {
      selectDataset.push({
        value: val.areacode,
        label: val.name,
      });
    });

    this.setState({ isListLoading: false, countyList: selectDataset });
  }

  async sendForm(obj) {
    this.taskSendForm = CancelableFetchPromise(fetch(`${process.env.REACT_APP_API}/api/manualforecast/admin/forecast/${this.props.match.params.id}`,
      {
        headers: {
          Authorization: `Bearer ${this.props.token}`,
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
        },
        method: 'PUT',
        body: JSON.stringify(obj),
      }), false);

    const json = await this.taskSendForm.promise;

    if (json.status === 401) {
      this.props.dispatchLogout();
      return;
    }

    if (json.status !== 200) {
      this.setState({
        error: true,
        errorMessage: {
          header: Localization.formatString(Localization.errorHeader, json.status),
          text: Localization.errorSendMessage,
        },
      });
      return;
    }
    this.props.history.push('/');
  }

  render() {
    return (
      <div className="t_admin">

        <div className="g_center-content">
          {this.state.error
            && (
            <ErrorMessage
              header={this.state.errorMessage.header}
              text={this.state.errorMessage.text}
            />
            )
          }
          {this.state.isForecastLoading || this.state.isListLoading
            ? <Spinner />
            : (
              <CreateNewWarning
                municipalityList={this.state.municipalityList}
                countyList={this.state.countyList}
                sendForm={this.sendForm}
                editForecast={this.state.forecast}
                goBack={() => this.props.history.push('/')}
                userIsAdmin={this.props.userIsAdmin}
              />
            )
          }
        </div>
      </div>
    );
  }
}

// export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdminEditForecast));
export default withRouter(AdminEditForecast);
